<template>
  <div>
    <Welcome
      v-if="rows.length === 0"
      @click="addRow"
    />
    <template v-else>
      <Row
        v-for="(row, i) in rows"
        :key="i"
        :price="itemsByRows[i] && itemsByRows[i].price"
        :number="i + 1"
        :data="row"
        v-bind="row"
        @addSection="addSection(row, $event)"
        @update:side="updateSide(row, $event)"
        @update:capacity="updateCapacity(row, $event)"
        @update="updateRow(row, $event)"
        @copy="copyRow(row, i, $event)"
        @remove="removeRow(row, i)"
      />
      <AddRow
        v-if="hasSections"
        @click="addRow"
      />
      <Accessories
        v-if="hasSections"
        :items-by-rows="itemsByRows"
        :wedge-anchors.sync="wedgeAnchors"
        @print="print"
        @download="download"
      />
      <EmailModal :pdf-data="pdfData" />
      <DealerModal :pdf-data="pdfData" />
    </template>
  </div>
</template>

<script>
import logic from './logic';
import Welcome from './components/Welcome.vue'
import Row from './components/Row.vue'
import AddRow from './components/AddRow.vue'
import Accessories from './components/Accessories.vue'
import EmailModal from './components/EmailModal.vue'
import DealerModal from './components/DealerModal.vue'

function normalizeUrl(url) {
  var a = document.createElement('a');
  a.href = url;
  return a.href;
}

function postOpen(url, data, close) {
  var form = document.createElement('form');
  form.method = 'post';
  form.action = normalizeUrl(url);

  var input;
  for (var name in data) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = data[name];
    form.appendChild(input);
  }

  var tmpWindow = window.open('', '_blank');
  tmpWindow.document.body.appendChild(form);
  form.submit();

  if (close) {
    tmpWindow.onload = function() {
      tmpWindow.close();
    };
  }
}

function getOptions(arr, key) {
  return [...new Set(arr.map(item => +item[key]))].sort((a, b) => a - b);
}

function checkCondition(condition, {capacity, depth, length}) {
  return !condition || eval(condition);
}

function getJson(url, cb) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.onload = () => {
      cb(JSON.parse(xhr.responseText));
    };
    xhr.send();
}

export default {
  name: 'App',
  provide () {
    return {
      options: this.options,
    };
  },
  components: {
    Welcome,
    Row,
    AddRow,
    Accessories,
    EmailModal,
    DealerModal,
  },
  data() {
    return {
      rows: [],
      items: null,
      itemsByRows: [],
      wedgeAnchors: false,
      options: {
        capacity: [300, 500],
        height: [],
        depth: [],
        width: [],
        count: [3, 4, 5, 6, 7, 8, 9],
      },
    };
  },
  computed: {
    hasSections() {
      return this.rows.some(row => row.sections.length);
    },
    pdfData() {
      return JSON.stringify({
        rows: this.rows,
        itemsByRows: this.itemsByRows,
      });
    },
  },
  watch: {
    rows: {
      deep: true,
      handler: 'calc',
    },
    wedgeAnchors: 'calc',
  },
  mounted() {
    // fetch(process.env.VUE_APP_DATA_URL).then(r => r.json()).then(this.setItems);

    getJson(process.env.VUE_APP_DATA_URL, (data) => {
      const external_ids = [];
      for (const type in data) {
        for (const item of data[type]) {
          external_ids.push(item.external_id);
        }
      }
      console.log(process.env.VUE_APP_PRODUCTS_URL, external_ids);

      getJson(process.env.VUE_APP_PRODUCTS_URL + '?external_ids=' + external_ids.join(','), (products) => {
        for (const type in data) {
          for (const item of data[type]) {
            const product = products[item.external_id];
            if (product && product.name && product.price) {
              item.name = product.name;
              item.price = product.price;
            }
          }
        }

        this.setItems(data);
      });
    });

    this.addRow();
  },
  methods: {
    setItems(data) {
      data.rack_kit.sort((a, b) => b.max_shelf - a.max_shelf);
      data.tier_shelf.sort((a, b) => b.max_length - a.max_length);

      this.items = Object.freeze(data);
      this.options.height = getOptions(this.items.rack_kit, 'height');
      this.options.depth = getOptions(this.items.tier_shelf, 'depth');
      this.options.width = getOptions(this.items.tier_shelf, 'length');
      this.calc();
    },
    calc() {
      if (!this.items)
        return;

      this.itemsByRows = this.rows.map(row => {
        return logic.getRowItems(this.items, row);
      });
    },
    print(download = false) {
      // const query = 'download=' + Number(download) + '&data=' + encodeURIComponent(this.pdfData);
      // window.open(process.env.VUE_APP_PDF_URL + '?' + query, '_blank');
      postOpen(process.env.VUE_APP_PDF_URL, {
        download: Number(download),
        data: this.pdfData,
      }, download);
    },
    download() {
      this.print(true);
    },
    addRow() {
      this.rows.push({
        side_wall: null,
        side_wall_count: 1,
        side_wall_left: false,
        side_wall_right: false,
        separate: true,
        height: 1600,
        depth: 300,
        capacity: {
          rack_kit_weight: 500,
          tier_shelf_weight: 100,
          rack_kit_strong: false,
          tier_shelf_strong: false,
          tier_shelf_ribs: false,
          fasteners: 'g2',
        },
        sections: [],
      });
    },
    addSection(row, data) {
      row.sections.push({
        isEdit: true,
        width: +data.width,
        count: +data.count,
        parts: +data.width / 30,
        accessories: {
          back_strips: false,
          back_strips_count: 0,
          side_strips: false,
          side_strips_count: 0,
          separators: false,
          separators_count: 0,
          back_wall: false,
          back_screen: false,
          back_screen_count: 0,
          side_wall_right: false,
          side_wall_left: false,
          side_screen: false,
          side_screen_count: 0,
        },
      });
    },
    updateCapacity(row, capacity) {
      row.capacity = capacity;
    },
    updateSide(row, data) {
      row.side_wall = data.side_wall;
      row.side_wall_count = data.side_wall_count;
      row.side_wall_left = data.side_wall_left;
      row.side_wall_right = data.side_wall_right;
    },
    updateRow(row, data) {
      if (row.separate !== data.separate) {
        const { rack_kit_weight, tier_shelf_weight } = logic.getWeight(data.separate, row.capacity);
        row.capacity.rack_kit_weight = rack_kit_weight;
        row.capacity.tier_shelf_weight = tier_shelf_weight;
      }

      row.separate = data.separate;
      row.height = +data.height;
      row.depth = +data.depth;
      if (row.sections[0]) {
        row.sections[0].width = +data.width;
        row.sections[0].count = +data.count;
      } else {
        this.addSection(row, data);
      }
    },
    copyRow(row, idx, count) {
      for (let i = 0; i < count; i++) {
        const newRow = {
          ...row,
          capacity: {...row.capacity},
          sections: row.sections.map((section) => ({
            ...section,
            accessories: {...section.accessories},
          })),
        };
        this.rows.splice(idx + 1, 0, newRow);
      }
    },
    removeRow(row, i) {
      this.rows.splice(i, 1);
    },
  },
}
</script>

<style>
  button {
    padding: 16px 32px;
    font-size: 16px;
    line-height: 18px;
    color: white;
    background: #F58214;
    border: 1px solid transparent;
  }
  button + button {
    margin-left: 16px;
  }
  button.outline {
    color: #F58214;
    background: white;
    border: 1px solid #F58214;
  }
</style>
